// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1G6Wy","link":"Footer_link__2MQgs","separator":"Footer_separator__2iS-C"};